import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxPivotGridComponent } from "devextreme-angular";


@Component({
    selector: 'acordioncomponente',
    templateUrl: './acordion.component.html',
    styleUrls: ['./acordion.component.scss'],
})

export class AcordionComponent implements AfterViewInit{
    consulta!: boolean;
    @Input() info!: any;
    data:any[] = [];

    constructor(private cdr: ChangeDetectorRef,private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
      this.groupData(this.info);
    }

    groupData(data:any) {
      const grouped: any = [];
      if(data){
        Object.keys(data).forEach((key: string) => {
          const item = data[key];
          if (!grouped[item.relacion]) {
            grouped[item.relacion] = [];
          }

          grouped[item.relacion].push(item);
        });

        this.data = Object.keys(grouped).map((relacion: string) => ({
          title: relacion,
          items: grouped[relacion]
        }));
      }else{
        this.data = [];
      }
    }

}
